import { useGetClients } from "modules/client/api";
import { Client } from "modules/client/types/client.interface";
import { useCallback, useMemo, useState } from "react";
import ClientTable, { RowObjClient } from "../default/components/clientTable";

const Clients = () => {
  const [searchName, setSearchName] = useState<string | undefined>(undefined);
  const { data, hasNextPage, fetchNextPage, fetchPreviousPage, isLoading } = useGetClients(searchName, 10);
  const [currentPage, setCurrentPage] = useState(1);
  
  // Memoize the current page data
  const flatData = useMemo(() => 
    data?.pages[currentPage - 1]?.data ?? [], 
    [data?.pages, currentPage]
  );

  // Memoize the formatted data
  const formattedData = useMemo((): RowObjClient[] => {
    return flatData.map((item: Client) => ({
      id: item._id,
      name: item.name,
      email: item.email ? item.email : [{ key: "-", value: "-" }],
      phoneNumber: item.phoneNumber ? item.phoneNumber : "-",
      address: item.address ? item.address : "-",
      postalCode: item.postalCode || "",
      city: item.city || "",
      codeClient: item.codeClient ? item.codeClient : "-",
      amountDue: item.amountDue || 0,
    }));
  }, [flatData]);

  const handleFetchNextPage = useCallback(() => {
    if (hasNextPage) {
      fetchNextPage();
      setCurrentPage(prev => prev + 1);
    }
  }, [hasNextPage, fetchNextPage]);

  const handleFetchPrevPage = useCallback(() => {
    if (currentPage > 1) {
      fetchPreviousPage();
      setCurrentPage(prev => prev - 1);
    }
  }, [currentPage, fetchPreviousPage]);

  const totalPage = data?.pages[0]?.count ? Math.ceil(data.pages[0].count / 10) : 1;

  return (
    <div>
      <div className="mt-5">
        <ClientTable
          tableData={formattedData}
          searchName={searchName || ""}
          setSearchName={setSearchName}
          currentPage={currentPage}
          totalPage={totalPage}
          hasNextPage={hasNextPage}
          handleFetchNextPage={handleFetchNextPage}
          handleFetchPrevPage={handleFetchPrevPage}
          isLoading={isLoading}
        />
      </div>
    </div>
  );
};

export default Clients;
